// extracted by mini-css-extract-plugin
module.exports = {"FilterHero":"FilterHero_FilterHero__g0mwZ"};